var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useGetAllMenuQuery } from "@/store/api";
import { useTranslation } from "react-i18next";
import { ETCRM_URL } from "@/utils/const";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight, } from "@fortawesome/pro-solid-svg-icons";
import { useState } from "react";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
export default function Placeholder() {
    var _a, _b;
    var menuResponse = useGetAllMenuQuery(null).data;
    var _c = useTranslation(["common"]), t = _c.t, i18n = _c.i18n;
    var _d = useState(null), openedMenu = _d[0], setOpenedMenu = _d[1];
    var main = ((_a = menuResponse === null || menuResponse === void 0 ? void 0 : menuResponse.data) === null || _a === void 0 ? void 0 : _a.main) || [];
    // Menu object
    var createMenu = function () {
        var list = main || {};
        var links = list.links;
        var mainMenu = [];
        for (var key in list.tabs) {
            var modules = list.tabs[key].modules;
            var moduleLinks = [];
            for (var moduleKey in modules) {
                moduleLinks[moduleKey] = {
                    modules: links[moduleKey],
                };
            }
            mainMenu[key] = { modules: moduleLinks };
        }
        return mainMenu;
    };
    // show or not children's menu
    var toggleMenu = function (item) {
        if (openedMenu === item) {
            setOpenedMenu(null);
        }
        else {
            setOpenedMenu(item);
        }
    };
    var menuItem = createMenu();
    return (_jsx("div", __assign({ className: "h-full px-2 py-4 overflow-auto bg-gray-50 dark:bg-gray-800" }, { children: _jsx("div", __assign({ className: "space-y-2 font-medium" }, { children: (_b = Object.keys(menuItem)) === null || _b === void 0 ? void 0 : _b.map(function (item, key) { return (_jsxs("div", __assign({ className: "menu-contain mx-2 ".concat(openedMenu === item ? "open" : "") }, { children: [_jsxs("p", __assign({ className: "menu-contain__label flex uppercase cursor-pointer text-justify p-2 relative ".concat(openedMenu === item ? "bg-[#eef1f7]" : "") }, { children: [_jsx("span", __assign({ className: "pr-4" }, { children: t(item) })), _jsx("span", __assign({ className: "absolute right-0 pr-2" }, { children: _jsx(FontAwesomeIcon, { icon: openedMenu === item ? faChevronDown : faChevronRight, onClick: function () { return toggleMenu(item); } }) }))] })), _jsx("ul", __assign({ className: openedMenu === item
                            ? "menu-contain__list block"
                            : "menu-contain__list hidden" }, { children: Object.values(menuItem[item]).map(function (i) {
                            return Object.values(i).map(function (m, key) { return (_jsx("li", __assign({ className: "hover:bg-[#eef1f7] px-2 py-1" }, { children: _jsx("a", __assign({ href: "".concat(process.env.PUBLIC_URL, "/modules/").concat(m.modules.module) }, { children: _jsxs("span", { children: [_jsx("span", { children: _jsx("img", { title: "".concat(t(m.modules.label)), src: "".concat(ETCRM_URL, "/").concat(t("app_lists.moduleIcons.".concat(m.modules.module))), width: "16px", height: "16px", className: "module-icon", alt: "" }) }), t(m.modules.label)] }) })) }), key)); });
                        }) }))] }), key)); }) })) })));
}
widgetsDictionary.register("dev/menuv", {
    name: "Exemple de menu vertical",
    display: Placeholder,
    selectable: false,
    settings: function () { return _jsx(_Fragment, { children: "[DEV/MENUV] - Widget settings" }); },
});
